(function () {
  var REQUIRED_COUNTS = {
    single: 1,
    pair: 2,
    set: 4
  };
  var activePreorderConfig = {};

  function parseJson(node, fallback) {
    if (!node) return fallback;

    try {
      return JSON.parse(node.textContent || '');
    } catch (error) {
      return fallback;
    }
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/[＿_・/／-]/g, '');
  }

  function formatVariantSearchText(variant) {
    var options = Array.isArray(variant.options) ? variant.options.join(' ') : '';
    return normalize([variant.title, variant.option1, variant.option2, variant.option3, options].join(' '));
  }

  function findVariant(variants, matchValue, fallbackName) {
    var match = normalize(matchValue || fallbackName);
    if (!match) return null;

    return variants.find(function (variant) {
      if (normalize(variant.option1) === match) return true;
      if (normalize(variant.title) === match) return true;
      return formatVariantSearchText(variant).indexOf(match) !== -1;
    }) || null;
  }

  function isInventoryEmpty(variant) {
    var quantity = Number(variant.inventory_quantity);
    if (!variant.inventory_management || Number.isNaN(quantity)) return false;
    return quantity <= 0;
  }

  function getSaleState(variant) {
    if (!variant) {
      return {
        key: 'missing',
        label: '未設定',
        selectable: false,
        isPreorder: false
      };
    }

    var emptyManagedInventory = isInventoryEmpty(variant);
    var preorderEnabled = Boolean(variant.preorderEnabled) || Boolean(activePreorderConfig.productPreorderEnabled);
    var autoPreorderWhenSoldOut = Boolean(activePreorderConfig.autoPreorderWhenSoldOut);
    var shouldPreorder = (emptyManagedInventory && (preorderEnabled || autoPreorderWhenSoldOut)) || (preorderEnabled && !variant.available);

    if (shouldPreorder) {
      return {
        key: 'preorder',
        label: '予約販売',
        selectable: true,
        isPreorder: true
      };
    }

    if (variant.available) {
      return {
        key: 'available',
        label: '通常販売',
        selectable: true,
        isPreorder: false
      };
    }

    return {
      key: 'soldout',
      label: '売り切れ',
      selectable: false,
      isPreorder: false
    };
  }

  function setMessage(panel, message, isError) {
    if (!panel) return;

    var messageNode = panel.querySelector('[data-pnca-message]');
    if (!messageNode) return;

    messageNode.textContent = message || '';
    messageNode.classList.toggle('is-error', Boolean(isError));
  }

  function selectedVariantsForMode(state, mode) {
    return (state.selected[mode] || []).map(function (variantId) {
      return state.variantById[String(variantId)] || null;
    });
  }

  function updateAddButton(root, state, mode) {
    var panel = root.querySelector('[data-pnca-panel="' + mode + '"]');
    if (!panel) return;

    var button = panel.querySelector('[data-pnca-add]');
    if (!button) return;

    var required = REQUIRED_COUNTS[mode] || 1;
    var variants = selectedVariantsForMode(state, mode).slice(0, required);
    var complete = variants.length === required && variants.every(Boolean);
    var hasPreorder = complete && variants.some(function (variant) {
      return getSaleState(variant).isPreorder;
    });

    button.textContent = hasPreorder ? button.dataset.preorderLabel : button.dataset.defaultLabel;
  }

  function updateSlotLabels(root, state, mode) {
    var slots = root.querySelectorAll('[data-pnca-panel="' + mode + '"] [data-pnca-slot]');
    slots.forEach(function (slot, index) {
      var valueNode = slot.querySelector('[data-pnca-slot-value]');
      var selectNode = slot.querySelector('[data-pnca-mobile-select]');
      var variantId = state.selected[mode][index];
      var variant = state.variantById[String(variantId)];

      valueNode.textContent = variant ? variant.option1 || variant.title : '未選択';
      if (selectNode) selectNode.value = variant ? String(variant.id) : '';
      updateSlotPreview(slot, variant);
    });
  }

  function findDesignSource(slot, variantId) {
    if (!variantId) return null;

    var stringId = String(variantId);
    var select = slot.querySelector('[data-pnca-mobile-select]');

    if (select) {
      var option = Array.prototype.slice.call(select.options).find(function (item) {
        return item.value === stringId;
      });

      if (option) return option;
    }

    return Array.prototype.slice.call(slot.querySelectorAll('[data-pnca-choice]')).find(function (choice) {
      return choice.dataset.variantId === stringId;
    }) || null;
  }

  function updateSlotPreview(slot, variant) {
    var preview = slot.querySelector('[data-pnca-selected-preview]');
    if (!preview) return;

    if (!variant) {
      preview.hidden = true;
      return;
    }

    var source = findDesignSource(slot, variant.id);
    var saleState = getSaleState(variant);
    var name = source && source.dataset.designName ? source.dataset.designName : variant.option1 || variant.title;
    var tone = source && source.dataset.designTone ? source.dataset.designTone : '';
    var price = variant.priceFormatted || (source && source.dataset.priceText) || '';
    var imageUrl = source && source.dataset.designImage ? source.dataset.designImage : '';
    var imageAlt = source && source.dataset.designAlt ? source.dataset.designAlt : name + 'デザインのMagSafeトレカホルダー';

    var image = preview.querySelector('[data-pnca-preview-image]');
    var placeholder = preview.querySelector('[data-pnca-preview-placeholder]');
    var nameNode = preview.querySelector('[data-pnca-preview-name]');
    var metaNode = preview.querySelector('[data-pnca-preview-meta]');
    var statusNode = preview.querySelector('[data-pnca-preview-status]');

    if (nameNode) nameNode.textContent = name;
    if (metaNode) metaNode.textContent = [tone, price].filter(Boolean).join(' / ');
    if (statusNode) {
      statusNode.textContent = saleState.key === 'preorder' ? '予約注文としてカートに追加されます' : saleState.label;
      statusNode.dataset.saleState = saleState.key;
    }

    if (image && placeholder) {
      if (imageUrl) {
        image.src = imageUrl;
        image.alt = imageAlt;
        image.hidden = false;
        placeholder.hidden = true;
      } else {
        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
        placeholder.textContent = name;
        placeholder.hidden = false;
      }
    }

    preview.hidden = false;
  }

  function setMode(root, state, mode) {
    if (!REQUIRED_COUNTS[mode]) return;

    state.activeMode = mode;

    root.querySelectorAll('[data-pnca-mode-tab]').forEach(function (tab) {
      var selected = tab.dataset.pncaModeTab === mode;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    root.querySelectorAll('[data-pnca-panel]').forEach(function (panel) {
      var active = panel.dataset.pncaPanel === mode;
      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
      if (active) setMessage(panel, '', false);
    });

    updateSlotLabels(root, state, mode);
    updateAddButton(root, state, mode);
  }

  function buildCartItems(variants, preorderConfig) {
    var groups = {};

    variants.forEach(function (variant) {
      var saleState = getSaleState(variant);
      var properties = {};

      if (saleState.isPreorder) {
        properties = {
          '販売形態': '予約販売',
          '予約受付期間': preorderConfig.preorderPeriod || '2026年6月1日〜2026年6月15日',
          '発送予定': variant.preorderShipWindow || preorderConfig.preorderShipWindow || '2026年6月25日〜2026年7月5日頃より順次発送'
        };
      }

      var key = String(variant.id) + '|' + JSON.stringify(properties);
      if (!groups[key]) {
        groups[key] = {
          id: variant.id,
          quantity: 0
        };

        if (Object.keys(properties).length) {
          groups[key].properties = properties;
        }
      }

      groups[key].quantity += 1;
    });

    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }

  function addToCart(root, state, mode) {
    var panel = root.querySelector('[data-pnca-panel="' + mode + '"]');
    var required = REQUIRED_COUNTS[mode] || 1;
    var selectedIds = state.selected[mode].slice(0, required);

    if (selectedIds.length < required || selectedIds.some(function (id) { return !id; })) {
      setMessage(panel, 'デザインを選択してください', true);
      return;
    }

    var variants = selectedIds.map(function (id) {
      return state.variantById[String(id)];
    });

    var unavailable = variants.find(function (variant) {
      return !variant || !getSaleState(variant).selectable;
    });

    if (unavailable) {
      setMessage(panel, '売り切れのデザインが含まれています', true);
      return;
    }

    var button = panel.querySelector('[data-pnca-add]');
    var originalLabel = button.textContent;
    var items = buildCartItems(variants, state.preorderConfig);

    setMessage(panel, 'カートに追加しています...', false);
    button.disabled = true;
    button.textContent = '追加中...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (response.ok) return response.json();

        return response.json().catch(function () {
          return {};
        }).then(function (errorBody) {
          throw new Error(errorBody.description || errorBody.message || 'カート追加に失敗しました');
        });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (error) {
        setMessage(panel, error.message || 'カート追加に失敗しました', true);
        button.disabled = false;
        button.textContent = originalLabel;
      });
  }

  function prepareChoices(root, state) {
    root.querySelectorAll('[data-pnca-choice]').forEach(function (button) {
      var variant = findVariant(state.variants, button.dataset.variantMatch, button.dataset.designName);
      var statusNode = button.querySelector('[data-pnca-choice-status]');
      var priceNode = button.querySelector('[data-pnca-choice-price]');
      var saleState = getSaleState(variant);

      if (variant) {
        button.dataset.variantId = String(variant.id);
        if (priceNode) priceNode.textContent = variant.priceFormatted || button.dataset.priceText;
      }

      button.dataset.saleState = saleState.key;
      if (statusNode) statusNode.textContent = saleState.label;

      if (!saleState.selectable) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function prepareMobileSelects(root, state) {
    root.querySelectorAll('[data-pnca-mobile-select]').forEach(function (select) {
      Array.prototype.slice.call(select.options).forEach(function (option, index) {
        if (index === 0) return;

        var variant = findVariant(state.variants, option.dataset.variantMatch, option.dataset.designName);
        var saleState = getSaleState(variant);
        var priceText = variant && variant.priceFormatted ? variant.priceFormatted : option.dataset.priceText;
        var statusText = saleState.key === 'preorder' ? ' / 予約販売' : saleState.key === 'soldout' ? ' / 売り切れ' : '';

        option.value = variant ? String(variant.id) : '';
        option.disabled = !saleState.selectable;
        option.textContent = (option.dataset.designName || 'デザイン') + ' / ' + priceText + statusText;
      });
    });
  }

  function updateAutoPreorderBanner(root, state) {
    var banner = root.querySelector('[data-pnca-auto-preorder]');
    if (!banner) return;

    var anyPreorderReady = Boolean(state.preorderConfig.autoPreorderWhenSoldOut) || Boolean(state.preorderConfig.productPreorderEnabled) || state.variants.some(function (variant) {
      return Boolean(variant.preorderEnabled);
    });

    var activePreorderCount = state.variants.filter(function (variant) {
      return getSaleState(variant).isPreorder;
    }).length;
    var totalCount = state.variants.length;
    var title = banner.querySelector('[data-pnca-auto-preorder-title]');
    var text = banner.querySelector('[data-pnca-auto-preorder-text]');
    var normalShippingText = state.preorderConfig.normalShippingText || '通常注文は2〜3営業日で発送予定です。';

    banner.hidden = !anyPreorderReady && activePreorderCount === 0;

    if (activePreorderCount > 0 && activePreorderCount === totalCount) {
      if (title) title.textContent = '現在予約注文受付中です';
      if (text) text.textContent = '全デザインが予約注文対象です。発送予定を確認してからご注文ください。';
    } else if (activePreorderCount > 0) {
      if (title) title.textContent = '一部デザインは予約注文で受付中です';
      if (text) text.textContent = '在庫があるデザインは通常発送、在庫0のデザインは予約注文として受け付けます。';
    } else {
      if (title) title.textContent = '在庫0になったデザインは予約注文に切り替わります';
      if (text) text.textContent = normalShippingText + ' 完売したデザインは発送予定を表示したうえで予約注文として受け付けます。';
    }
  }

  function updateSaleSummary(root, state) {
    var summary = root.querySelector('[data-pnca-sale-state]');
    if (!summary) return;

    var copy = root.querySelector('[data-pnca-sale-state-copy]');
    var quickSummary = root.querySelector('[data-pnca-quick-sale-state]');
    var preorderCount = state.variants.filter(function (variant) {
      return getSaleState(variant).isPreorder;
    }).length;
    var selectableCount = state.variants.filter(function (variant) {
      return getSaleState(variant).selectable;
    }).length;
    var totalCount = state.variants.length;
    var normalShippingText = state.preorderConfig.normalShippingText || '通常注文は2〜3営業日で発送予定です。';

    if (preorderCount > 0 && preorderCount === totalCount) {
      summary.textContent = '現在予約注文受付中です';
      if (quickSummary) quickSummary.textContent = '現在予約注文受付中です';
      if (copy) copy.textContent = '全デザインが予約注文対象です。発送予定期間を必ず確認してからご注文ください。';
    } else if (preorderCount > 0) {
      summary.textContent = '一部商品予約中です';
      if (quickSummary) quickSummary.textContent = '一部商品予約中です';
      if (copy) copy.textContent = '在庫があるデザインは通常発送、在庫0のデザインは予約注文として受け付けます。';
    } else if (selectableCount > 0) {
      summary.textContent = '通常販売中です';
      if (quickSummary) quickSummary.textContent = '通常販売中です';
      if (copy) copy.textContent = normalShippingText + ' 在庫がなくなったデザインは予約注文に切り替わります。';
    } else {
      summary.textContent = '現在は売り切れです';
      if (quickSummary) quickSummary.textContent = '現在は売り切れです';
      if (copy) copy.textContent = '現在選択できるデザインがありません。再入荷や予約販売の設定をご確認ください。';
    }
  }

  function selectChoice(root, state, button) {
    if (button.disabled || !button.dataset.variantId) return;

    var mode = button.dataset.mode;
    var slotIndex = Number(button.dataset.slotIndex);
    var variantId = button.dataset.variantId;

    state.selected[mode][slotIndex] = variantId;

    root.querySelectorAll('[data-pnca-choice][data-mode="' + mode + '"][data-slot-index="' + slotIndex + '"]').forEach(function (choice) {
      choice.setAttribute('aria-pressed', choice === button ? 'true' : 'false');
    });

    updateSlotLabels(root, state, mode);
    updateAddButton(root, state, mode);

    var panel = root.querySelector('[data-pnca-panel="' + mode + '"]');
    if (panel) setMessage(panel, '', false);
  }

  function selectMobileOption(root, state, select) {
    var mode = select.dataset.mode;
    var slotIndex = Number(select.dataset.slotIndex);
    var variantId = select.value || null;

    state.selected[mode][slotIndex] = variantId;

    root.querySelectorAll('[data-pnca-choice][data-mode="' + mode + '"][data-slot-index="' + slotIndex + '"]').forEach(function (choice) {
      choice.setAttribute('aria-pressed', variantId && choice.dataset.variantId === variantId ? 'true' : 'false');
    });

    updateSlotLabels(root, state, mode);
    updateAddButton(root, state, mode);

    var panel = root.querySelector('[data-pnca-panel="' + mode + '"]');
    if (panel) setMessage(panel, '', false);
  }

  function selectDesignFromCard(root, state, matchValue) {
    var mode = state.activeMode || 'single';
    var panel = root.querySelector('[data-pnca-panel="' + mode + '"]');
    var selector = '[data-pnca-choice][data-mode="' + mode + '"][data-slot-index="0"]';
    if (!panel) return;

    var choice = Array.prototype.slice.call(panel.querySelectorAll(selector)).find(function (button) {
      return normalize(button.dataset.variantMatch) === normalize(matchValue);
    });

    if (choice && !choice.disabled) selectChoice(root, state, choice);
  }

  function init(root) {
    var variants = parseJson(root.querySelector('[data-pnca-magsafe-variants]'), []);
    var preorderConfig = parseJson(root.querySelector('[data-pnca-magsafe-preorder]'), {});
    activePreorderConfig = preorderConfig;
    var state = {
      variants: variants,
      preorderConfig: preorderConfig,
      variantById: {},
      selected: {
        single: [null],
        pair: [null, null],
        set: [null, null, null, null]
      },
      activeMode: 'single'
    };

    variants.forEach(function (variant) {
      state.variantById[String(variant.id)] = variant;
    });

    prepareChoices(root, state);
    prepareMobileSelects(root, state);
    updateSaleSummary(root, state);
    updateAutoPreorderBanner(root, state);

    root.querySelectorAll('[data-pnca-mode-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        setMode(root, state, tab.dataset.pncaModeTab);
      });

      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

        var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pnca-mode-tab]'));
        var currentIndex = tabs.indexOf(tab);
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(currentIndex + direction + tabs.length) % tabs.length];

        event.preventDefault();
        next.focus();
        setMode(root, state, next.dataset.pncaModeTab);
      });
    });

    root.querySelectorAll('[data-pnca-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        selectChoice(root, state, button);
      });
    });

    root.querySelectorAll('[data-pnca-mobile-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        selectMobileOption(root, state, select);
      });
    });

    root.querySelectorAll('[data-pnca-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        addToCart(root, state, button.dataset.mode);
      });
    });

    root.querySelectorAll('[data-pnca-scroll-target]').forEach(function (button) {
      button.addEventListener('click', function () {
        var mode = button.dataset.pncaSetMode;
        var target = document.querySelector(button.dataset.pncaScrollTarget);

        if (mode) setMode(root, state, mode);
        if (button.dataset.pncaSelectDesign) selectDesignFromCard(root, state, button.dataset.pncaSelectDesign);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    setMode(root, state, 'single');
  }

  function boot() {
    document.querySelectorAll('[data-pnca-magsafe-lp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
